module.exports = __webpack_public_path__ + "img/coach-bg.e28007ef.png";